module.exports = __webpack_public_path__ + "watermark-color.330a4c48b3784bdd2327985ebf08314b.svg";